function initArticleCorrection() {

    $('.js_modalOpen').magnificPopup({
        type:'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
}


function setModalClose() {

    $('.js_modalClose').on('click', function(evt) {
        evt.preventDefault();

        var magnificPopup = $.magnificPopup.instance;
        magnificPopup.close();

    });
}


setModalClose();
initArticleCorrection();
